import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { INAAction } from '../../model/ina-action';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { LstQuestionValueDataView, Section } from '../model/inaSchoolEnrollments';
import { Shared } from '../../service/shared';
import { InaService } from '../../service/ina.service';
import { StepAction } from '../model/stepAction';
import { TrackingHistories, TrackingHistory } from '../../service/history';


@Component({
  selector: 'app-elementary',
  templateUrl: './elementary.component.html',
  styleUrls: ['./elementary.component.scss']
})
export class ElementaryComponent implements OnInit {
  @Input('step') step: number;
  @Input('action') action: INAAction;
  @Output() prevOrNextStep = new EventEmitter<StepAction>();
  @Output() updateHistory =new EventEmitter<TrackingHistory>();

  frmElementary: UntypedFormGroup;
  section: Section;
  notifyAction: string = '';
  inaStatusTypeId: number;

  shared: Shared;
  lYear: string = ''; lGrade: string = '';
  mYear: string = ''; mGrade: string = '';
  eYear: string = ''; eGrade: string = '';
  lstTrackHistory: TrackingHistory[] = [];
  trackHistories: TrackingHistories = new TrackingHistories();
  constructor(
    private fb: UntypedFormBuilder, 
    private inaService: InaService
  ) {
    this.shared = new Shared(inaService);
    this.trackHistories.inaHistory = [];

    this.frmElementary = this.fb.group({
      radioArtStandardMet: [],
      radioMathStandardMet: [],
      radioProficient: [],
      languageComments: [],
      radioUnaddressedCreditDeficiency: [],
      unaddressedComments: []

    });
  }

  ngOnInit(): void {
    let sectionId: number = 22;
    this.inaService.inaSelectionSubject$.subscribe(x => {
      this.section = x.inaSchoolEnrollment.Sections.find(x => x.SectionID == sectionId)!;
      this.inaStatusTypeId = x.inaSchoolEnrollment.InaSchoolEnrollment.StatusTypeId;
      if (!this.frmElementary.dirty) {
        this.frmElementary.reset();
        this.setFormValue();
      }
    });

    this.inaService.inaHistorySelectionSubject$.subscribe((x: TrackingHistories) => {
      if (x.inaHistory?.length >= 1) {
        this.trackHistories.inaHistory = x.inaHistory.filter(x => x.ChangedField.split(',')[0] == sectionId.toString());
      }

    });

    if (this.action == INAAction.View) {
      this.frmElementary.disable();
    }
    else {
      this.frmElementary.valueChanges.subscribe(() => {
        this.updateChangeValue();
      });
    }
  }

  setFormValue() {
    this.getListQuestionValueData(334, 'Language Arts').forEach(
      x => {
        if (x.Name == 'Language Arts Year')
          this.lYear = x.Value;
        else if (x.Name == 'Assessed Grade')
          this.lGrade = x.Value;
        else if (x.Name == 'Standard Met or Exceeded' && this.lYear.length > 0) 
          this.radioArtStandardMet.setValue(x.Value == 'True' ? "1" : "2");
      }
    );

    this.getListQuestionValueData(338, 'Math').forEach(
      x => {
        if (x.Name == 'Math Year')
          this.mYear = x.Value;
        else if (x.Name == 'Assessed Grade')
          this.mGrade = x.Value;
        else if (x.Name == 'Standard Met or Exceeded' && this.mYear.length > 0)
          this.radioMathStandardMet.setValue(x.Value == 'True' ? "1" : "2");

      }
    );

    this.getListQuestionValueData(342, 'ELPAC').forEach(
      x => {
        if (x.Name == 'ELPAC Year')
          this.eYear = x.Value;
        else if (x.Name == 'Assessed Grade')
          this.eGrade = x.Value;
        else if (x.Name == 'Proficient' && this.eYear.length > 0)
          this.radioProficient.setValue(x.Value == 'True' ? "1" : "2");
      }
    );

    this.radioArtStandardMet.disable();
    this.radioMathStandardMet.disable();
    this.radioProficient.disable();
    this.languageComments.setValue(this.getQuestionValue(346, 'Assessment Comments'));

  }

  getListQuestionValueData(questionId: number, questionName: string): LstQuestionValueDataView[] {
    {
      return this.shared.getListQuestionValueData(this.section, questionId, questionName);
    }
  }

  getQuestionValue(questionId: number, questionName: string): string {
    return this.shared.getQuestionValue(this.section, questionId, questionName);
  }
  /*
  setStep(index: number) {
    this.step = index;
    let s: StepAction = new StepAction();
    s.stepNumber = this.step;
    this.prevOrNextStep.emit(s);
  }  
  nextStep() {
    this.notifyAction = 'Next';
    this.notifyChanges(0);
  }
  prevStep() {
    this.notifyAction = 'Prev';
    this.notifyChanges(0);
  }
  notifyChanges(action:number) {
      let s: StepAction = new StepAction();
      s.stepNumber = 5;
      s.action = action == 1 ? '': this.notifyAction ;
      s.section = new Section();
      if (this.frmElementary.dirty) {
        this.updateChangeValue();
        s.section = this.section;
        s.lsttrackingHistory=this.lstTrackHistory;
        this.lstTrackHistory=[];
      }
      this.prevOrNextStep.emit(s);    
  }
  */

  updateChangeValueLostFocus()
  {
    if (this.languageComments.dirty) {
      this.setListQuestionValue(346, 'Assessment Comments', this.languageComments.value);
      this.languageComments.markAsPristine();
    }
  }
  updateChangeValue() {
    let radioVal: string = '';
    if (this.radioArtStandardMet.dirty) {
      radioVal = this.radioArtStandardMet.value == 1 ? "True" : this.radioArtStandardMet.value == 2 ? "False" : "";
      this.setListQuestionValue(334, 'Standard Met or Exceeded', radioVal);
    }
    if (this.radioMathStandardMet.dirty) {
      radioVal = this.radioMathStandardMet.value == 1 ? "True" : this.radioMathStandardMet.value == 2 ? "False" : "";
      this.setListQuestionValue(338, 'Standard Met or Exceeded', radioVal);
    }
    if (this.radioProficient.dirty) {
      radioVal = this.radioProficient.value == 1 ? "True" : this.radioProficient.value == 2 ? "False" : "";
      this.setListQuestionValue(342, 'Proficient', radioVal);
    }

  }


  setListQuestionValue(questionId: number, questionName: string, value: string) {    
    this.setTrackingHistory(questionId, questionName, value);
    this.shared.setListQuestionValue(this.section, questionId, questionName, value);
    
  }
  setTrackingHistory(questionId: number, questionName: string, value: string) {
    if (this.inaStatusTypeId == 2) {
      var tempTrackingHistory: TrackingHistory = this.shared.setTrackingHistory(this.section, questionId, questionName, value);
      this.updateHistory.emit(tempTrackingHistory);      
    }
  }


  get radioArtStandardMet(): any { return this.frmElementary.get('radioArtStandardMet'); }
  get radioMathStandardMet(): any { return this.frmElementary.get('radioMathStandardMet'); }
  get radioProficient(): any { return this.frmElementary.get('radioProficient'); }

  get languageComments(): any { return this.frmElementary.get('languageComments'); } //AssessmentComments
  get radioUnaddressedCreditDeficiency(): any { return this.frmElementary.get('radioUnaddressedCreditDeficiency'); }
  get unaddressedComments(): any { return this.frmElementary.get('unaddressedComments'); } //creditDeficientComments
}
